module.exports = __webpack_public_path__ + "img/code.89096c74.png";